import {
  ADMIN_CASES_REQUEST,
  BULK_UPDATE_CASES_REQUEST,
  SET_LAST_ADMIN_CASE_VIEWED,
  TOGGLE_BULK_COLUMNS,
} from "../adminConstants";

// NOTE: would be nice to re-use the openapi options arguments here for TS
export const fetchAdminCases = (payload = {}) => {
  return {
    type: ADMIN_CASES_REQUEST,
    payload,
  };
};

export const setAdminLastCaseViewed = (id: number) => {
  return {
    type: SET_LAST_ADMIN_CASE_VIEWED,
    payload: id,
  };
};

export const bulkUpdateCases = (
  caseIds: number[],
  bulkAction: string,
  updateValue: any
) => {
  return {
    type: BULK_UPDATE_CASES_REQUEST,
    payload: {
      caseIds,
      bulkAction,
      updateValue,
    },
  };
};

export const toggleBulkAssignColumns = () => {
  return {
    type: TOGGLE_BULK_COLUMNS,
  };
};
